t = require('app/scripts/views/internal/teacup-with-helpers')('popover_select_members')

module.exports = t.renderable ({ canInviteMembers, includeOrgMembers }) ->
  memberSection = (headingKey) ->
    t.h4 ->
      t.format headingKey

    t.div '.js-loading', ->
      t.p '.empty', { style: 'padding: 24px 6px' }, ->
        t.format 'loading'

    t.div '.js-no-results.hide', ->
      t.p '.empty', { style: 'padding: 24px 6px' }, ->
        t.format 'no-results'

    t.ul '.pop-over-member-list.checkable.u-clearfix.js-mem-list'

  t.input '.js-search-mem.js-autofocus', { type: 'text', placeholder: t.l('search-members') }

  t.div '.pop-over-section.js-suggestions', ->
    t.h4 ->
      t.icon 'sparkle'
      t.format 'suggested'

    t.ul '.pop-over-member-list.checkable.u-clearfix.js-mem-list'

    t.a '.suggested-actions-feedback.js-suggested-actions-feedback', { href: '#' }, ->
      t.format 'feedback'

  t.div '.pop-over-section.js-board-members', ->
    memberSection('board-members')

  if includeOrgMembers
    t.div '.pop-over-section.js-org-members', ->
      memberSection('team-members')

    t.div '.js-show-org-members', ->
      t.a '.subtle.button.full', { href: '#', style: 'margin-top: 8px;' }, ->
        t.format 'show-team-members'

  t.div '.js-invite-no-results.hide', ->
    t.p '.empty', { style: 'padding: 24px 6px' }, ->
      if canInviteMembers then t.l('not-a-member') else t.l('no-results')

  t.div '.js-invite-results.hide'

  t.div '.js-invite-error.hide', ->
    t.p '.error',  { style: 'margin: 16px 8px 6px;' }
